export default {
    oldPassword: '旧パスワード',
    newPassword: '新パスワード',
    newPasswordConfirm: '新パスワード(確認)'
};
